import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BlockList from 'components/application/BlockList';

export default function CourseSidePanelRolesTab({ courseCompanyRoles }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  // order courseCompanyRoles alphabetically
  const orderedCourseCompanyRoles = [...courseCompanyRoles].sort((a, b) =>
    a.rolePosition.localeCompare(b.rolePosition, 'en', { sensitivity: 'base' }),
  );

  return (
    <div key='rolesTab' label='roles'>
      <BlockList
        collection={orderedCourseCompanyRoles}
        onItemDisplay={(courseCompanyRole) => (
          <div className='tw-flex tw-flex-col'>
            <span className='tw-text-m tw-text-grey-700'>
              {courseCompanyRole.rolePosition}
            </span>
            <span className='tw-text-s tw-text-grey-500'>
              {courseCompanyRole.required ?
                i18nTShared('required')
              : i18nTShared('optional')}
            </span>
          </div>
        )}
      />
    </div>
  );
}

CourseSidePanelRolesTab.propTypes = {
  courseCompanyRoles: PropTypes.array.isRequired,
};
